import React, { useMemo } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { RESULTS_PATH } from 'containers/App/Routes';
import { EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';
import Logger from 'utils/Logger';

/**
 * Redirect to either checkout-v2 or checkout-v3 based on the experiment variant
 */
export const CheckoutRedirect = () => {
  const { clinicId } = useParams<{ clinicId: string; }>();

  const { isVariant: isAuthFlowVariant } = useExperiment({
    experiment: EXPERIMENTS.CHECKOUT_REDESIGN_AUTH_FLOW,
    skipTracking: true,
    condition: Boolean(clinicId),
  });

  const checkoutPath = useMemo(
    () => isAuthFlowVariant ? 'checkout-v3' : 'checkout-v2',
    [isAuthFlowVariant],
  );

  const redirectPath = useMemo(
    () => `${RESULTS_PATH}/${clinicId}/${checkoutPath}`,
    [clinicId, checkoutPath],
  );

  if (!clinicId) {
    Logger.error('No clinicId passed to CheckoutRedirect', { clinicId });
    return null;
  }

  return <Redirect to={redirectPath} />;
};
